import { Component, Input, OnInit } from "@angular/core";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import * as $ from "jquery";
import Swal from "sweetalert2";

@Component({
  selector: "app-laudo-list",
  templateUrl: "./laudo-list.component.html",
  styleUrls: ["./laudo-list.component.css"],
})
export class LaudoListComponent implements OnInit {
  @Input() listaLaudos: any = [];
  @Input() prontuario: any = {};
  laudo: any = {};

  constructor(public global: Global, public service: ApiService) {}

  ngOnInit() { 
    this.listarLaudos();  
  } 

  visualizarDeclaracao(laudo) {
    this.laudo = laudo;

    $("#modalVisualizarLaudo").toggleClass("show");
    $("#modalVisualizarLaudo").css("display", "block");
  }

  fecharModal = () => {
    $("#modalVisualizarLaudo").toggleClass("show");
    $("#modalVisualizarLaudo").css("display", "none");
  };

  listarLaudos(){
    this.service.Get(`Prontuario/${this.prontuario.id}/ProntuarioLaudo`).then((res) => {
      if (res) {
        this.listaLaudos = res;
      }
    }
    ).catch((err) => {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao listar laudos!",
      }).then(() => {
        Swal.close();
      });
    }
    );

  }
  imprimirDado(item: any) {    
    var tipo_laudo = "";
    if (item.tipo_laudo === "LIVRE") {
      tipo_laudo = "LAUDO_LIVRE.frx";
    } else if (item.tipo_laudo === "PADRAO") {
      tipo_laudo = "LAUDO_PADRAO.frx";
    }

    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .PostImpresso(`Documento/impresso-pdf/` + tipo_laudo, [
        {
          nome: "id",
          valor: item.id.toString(),
        },
      ])
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      }).catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao enviar a declaração!",
          }).then(() => {
            Swal.close();
          });
        });;
  }

    enviarWhatsApp(item: any) {
      Swal.fire("Favor aguarde");
      Swal.showLoading();
      var tipoDeclaracaoImpresso: Number = 10;
      if (item.tipo_laudo == "LIVRE") tipoDeclaracaoImpresso = 10;
  
      this.service
        .Get(
          `Documento/impresso/Whatsapp/ ${item.id}?atendimento_id=${this.prontuario.atendimento_id}&tipo_documento=${tipoDeclaracaoImpresso}`
        )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: "Declaração enviada com sucesso!",
          }).then(() => {
            Swal.close();
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao enviar a declaração!",
          }).then(() => {
            Swal.close();
          });
        });
    }
  
}
